import React from 'react'
import { IsAuthorizeUser } from '../utils/AuthenticationLibrary';
import UnauthorizedPage from '../components/common/error/UnauthorizedPage';
import ComponentNavigation from '../navigation/ComponentNavigation';
import { Redirect } from 'react-router-dom';
import { QueryParams } from '../navigation/NavigationLib';

const AuthorizationWrap = (props) => {

    const newStr = window.location.hash.substring(2);
    let mainPart;
    const urlParams = QueryParams(props.location.pathname);
    if (urlParams.length > 0 && urlParams[0] !== "") {
        mainPart = newStr.split('/')[0];
    } else {
        mainPart = newStr;
    }
    
    const breadCrumb = ComponentNavigation.find(item => item.id.toLowerCase() === mainPart.toLowerCase());

    if (window.location.hash === "/#/login" || window.location.hash === "#/login" || window.location.hash === "#/" || window.location.hash === "/") {
        return <Redirect from="/" to="/login" />;
    }

    return (
        <>
            {
                (IsAuthorizeUser(breadCrumb?.allowrole)) ?
                    props.children :
                    <UnauthorizedPage></UnauthorizedPage>
            }
        </>
    );
}

export default AuthorizationWrap